// The single place the app's custom elements are registered. Each define is guarded so a
// double-import (or a test re-import) doesn't throw the "already defined" error.

import { FavoriteToggle } from "./favorite-toggle.js";
// Importing the countdown-timer module registers its tag as a side effect (it calls
// customElements.define at load), so there's no define for it here.
import "./countdown-timer.ts";

if (!customElements.get("favorite-toggle")) {
  customElements.define("favorite-toggle", FavoriteToggle);
}
